
/**
 * Домашняя страница.
 *
 */

import { Component, Vue } from 'vue-property-decorator';

import Layout from '@/layouts/Default.vue';
import TitlePage from '@/components/Title.vue';

@Component({
    components: {
        Layout,
        TitlePage,
    },
})
export default class PageNotFound extends Vue {}
